/**
 * Size chart trigger + modal (trigger: snippets/size-chart-trigger.liquid,
 * dialog: snippets/size-chart-dialog.liquid, rendered from layout/theme.liquid).
 *
 * Uses event delegation on `document` instead of per-node listeners, so the
 * trigger keeps working no matter where it ends up or how often the
 * surrounding markup gets rewritten by scripts/apps.
 *
 * Loaded once, theme-wide:
 *   <script src="{{ 'size-chart-modal.js' | asset_url }}" defer></script>
 */
(function () {
  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function resolveDialogForTrigger(trigger) {
    const dialogId = trigger.getAttribute('aria-controls');
    if (dialogId) {
      const byId = document.getElementById(dialogId);
      if (byId) return byId;
    }
    return trigger.closest('size-chart-modal')?.querySelector('dialog') || null;
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-chart-open]');
    if (trigger) {
      openDialog(resolveDialogForTrigger(trigger));
      return;
    }

    const closeButton = event.target.closest('[data-size-chart-close]');
    if (closeButton) {
      closeDialog(closeButton.closest('dialog'));
      return;
    }

    // Native <dialog> reports a click on its own ::backdrop area as a click
    // on the dialog element itself (event.target === the <dialog>).
    if (event.target.matches && event.target.matches('dialog.size-chart__dialog')) {
      closeDialog(event.target);
    }
  });

  // The dialog's native "close" event doesn't bubble, but a capture-phase
  // listener on `document` still sees it for every size-chart dialog.
  document.addEventListener(
    'close',
    function (event) {
      if (event.target.matches && event.target.matches('dialog.size-chart__dialog')) {
        const trigger = document.querySelector(`[aria-controls="${CSS.escape(event.target.id)}"]`);
        trigger?.focus();
      }
    },
    true
  );

  // --- Keep the trigger next to the "Size" label --------------------------
  // Some swatch layouts rebuild the variant picker client-side. If the
  // trigger isn't already next to the Size label, move it there. This is a
  // no-op on layouts where snippets/variant-picker.liquid already renders
  // the trigger inside the size row.
  var SIZE_WORDS = ['size', 'maat', 'größe'];

  function relocateSizeChartTrigger() {
    var trigger = document.querySelector('[data-size-chart-open]');
    if (!trigger) return;
    if (trigger.closest('.swatch-size-chart')) return;
    if (trigger.closest('[data-option-aside]')) return;

    var labels = document.querySelectorAll('.swatch-option-name');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var text = (label.textContent || '').trim().toLowerCase();
      if (SIZE_WORDS.indexOf(text) === -1) continue;
      var container = label.closest('label') || label.parentElement;
      if (container && !container.contains(trigger)) {
        container.appendChild(trigger);
      }
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateSizeChartTrigger);
  } else {
    relocateSizeChartTrigger();
  }

  var relocateObserver = new MutationObserver(function () {
    relocateSizeChartTrigger();
  });
  relocateObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    relocateObserver.disconnect();
  }, 5000);
})();
